import { AttentiveIntegrationPurpose } from "@redotech/redo-model/attentive-integration";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const updateAttentiveIntegrationPurposes = {
  name: "updateAttentiveIntegrationPurposes" as const,
  input: z.object({
    purposes: z.array(createEnum(AttentiveIntegrationPurpose)),
    action: createEnum(["add", "remove"]),
  }),
  output: z.object({
    success: z.boolean(),
  }),
};
